<template>
    <ValidationObserver
        ref="testCalculation"
        v-slot="{ passes}"
    >
        <BaseDialog
            :showDialog="showDialog"
            headline="lang_PUBLISHING_WORKS_ACTION_OPTION_TEST_CALCULATION_SVD"
            :close="closeDialog"
            maxDialogWidth="1500"
            maxCardHeight="800"
            :alvqa="alvqa"
        >
            <template v-slot:dialogText>
                <v-container fluid>
                    <v-row class="pl-3 headline">
                        {{ getWorkName() }}
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <BaseEditPageDropdown 
                                :context="context"
                                field="Rights"
                                :items="rightsItems" 
                                :label="$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_TYPE_OF_RIGHTS')"
                                :selection="true"
                                rules="required"
                                :withMargin="false"
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-rights'"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField 
                                    :context="context"
                                    field="AtSource"
                                    label="At Source"
                                    rules="amount"
                                    :withMargin="false"
                                    :alvqa="alvqa + '-textfield-at-source'"
                                />
                        </v-col>
                        <v-col>
                            <BaseEditPageTextField 
                                    :context="context"
                                    field="Amount"
                                    :label="$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_AMOUNT')"
                                    rules="amount"
                                    :withMargin="false"
                                    :alvqa="alvqa + '-textfield-amount'"
                                    :suffix="$store.getters.getSelectedCurrency"
                                />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="SharePercent"
                                label="Share"
                                suffix="%"
                                rules="percentDecimal"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-share-percent'"
                            /> 
                        </v-col>
                        <v-col>
                            <BaseEditPageDropdown 
                                :context="context"
                                field="Country"
                                :items="countryItems" 
                                :label="$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_ORIGINATING_COUNTRY')"
                                :selection="true"
                                :withMargin="false"
                                :alvqa="alvqa + '-dropdown-country'"
                            />
                        </v-col>
                    </v-row>
                    <!-- <v-row class="mb-4">
                        <v-col>
                            <BaseCheckbox 
                                :context="context"
                                :label="$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_RULE_FOR_SPW')"
                                :valueOuter="'newSpw'"
                                hideDetails
                                :alvqa="alvqa + '-checkbox-new-spw'"
                                class="mt-0"
                            />
                        </v-col>
                    </v-row> -->
                    <v-divider class="mb-2" />
                    <v-row v-if="errorMessage !== null">
                        <v-col>
                            <v-chip  
                                small 
                                label
                                color="errorLineChip"
                                text-color="errorLineText"
                                class="mb-6 mt-5"
                                :alvqa="alvqa + 'result-chip-error'"
                            >{{ $t('lang_GENERAL_CAPTION_ERROR') }}</v-chip>
                            {{  $t(errorMessage) }}
                        </v-col>
                    </v-row>
                    <v-row v-for="(entry, sparte) in result" :key="sparte">
                        <v-col>
                            <v-chip 
                                label 
                                color="resultHeadlineBackground" 
                                text-color="resultHeadlineText"
                                :alvqa="alvqa + '-result-list-chip-type-of-right-' + sparte.toLowerCase().replace(/\s+/g, '-')"
                            >{{ $t(sparte) }}</v-chip>
                            <v-row>
                                <v-col>
                                    <v-data-table
                                        v-if="entry[0].error === -1"
                                        :headers="resultHeaders"
                                        :items="entry"
                                        hide-default-footer
                                        disable-sort
                                        dense
                                        :items-per-page="itemsPerPage"
                                    >
                                        <template v-slot:item="{ item, index }">
                                            <tr>
                                                <td>
                                                    <v-chip  
                                                        small 
                                                        label
                                                        color="excelLineChip"
                                                        text-color="excelLineText"
                                                        :alvqa="alvqa + 'result-list-row-' + sparte.toLowerCase().replace(/\s+/g, '-') + '-chip-excel'"
                                                    >
                                                        <span class="mr-2 ml-1">{{ $t('lang_GENERAL_CAPTION_EXCEL') }}</span>
                                                    </v-chip>
                                                </td> 
                                                <td 
                                                    class="ellipsis"
                                                    :alvqa="alvqa + '-result-list-' + sparte.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-statement-for'"
                                                ><BaseTooltip :simpleText="item.name_alv" /></td>
                                                <td 
                                                    class="text-right"
                                                    :alvqa="alvqa + '-result-list-' + sparte.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-amount'"
                                                 > {{ $alvPlugin.getNumberLocalization(item.total_net_val, 'number') }}</td>
                                                <td 
                                                    class="text-right"
                                                    :alvqa="alvqa + '-result-list-' + sparte.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-base-percent'"
                                                > {{ $alvPlugin.getNumberLocalization(item.contract_base, 'number') }} </td>
                                                <td 
                                                    class="text-right"
                                                    :alvqa="alvqa + '-result-list-' + sparte.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-share-percent'"
                                                > {{ $alvPlugin.getNumberLocalization(item.contract_share, 'number') }} </td>
                                                <td 
                                                    class="text-right"
                                                    :alvqa="alvqa + '-result-list-' + sparte.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-share-amount'"
                                                > {{ $alvPlugin.getNumberLocalization(item.eur_net, 'number') }} </td>
                                                <td 
                                                    class="ellipsis"
                                                    :alvqa="alvqa + '-result-list-' + sparte.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-calculation-rule'"
                                                ><BaseTooltip :simpleText="item.rule_applied" /></td>
                                                <td 
                                                    class="no_ellipsis"
                                                    :alvqa="alvqa + '-result-list-' + sparte.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-publishing-contract'"
                                                > {{ item.contract_match_id }}</td>
                                                <td 
                                                    class="no_ellipsis"
                                                    :alvqa="alvqa + '-result-list-' + sparte.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-contract-type'"
                                                > {{ item.type_of_contract }}</td>
                                            </tr>
                                            <tr v-if="item.rowInfo !== undefined">
                                                <td></td>
                                                <td colspan="8" :alvqa="alvqa + 'result-list-row-' + sparte.toLowerCase().replace(/\s+/g, '-') + '-contract-line'">
                                                        <v-chip  
                                                            small 
                                                            label
                                                            color="contractLineChip"
                                                            class="mr-6"
                                                            :alvqa="alvqa + 'result-list-row-' + sparte.toLowerCase().replace(/\s+/g, '-') + '-chip-contract'"
                                                        >{{ $t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_CONTRACT_ROW') }}</v-chip>
                                                        {{ $t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_RIGHT_TYPE') }}: {{ item.rowInfo.rights !== '' ? $t(getContractRightConst(item.rowInfo.rights)) : '--' }} | 
                                                        {{ $t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_SHARE') }}: {{ item.rowInfo.percent !== '' ? $n(item.rowInfo.percent, 'number') : '--' }} % | 
                                                        {{ $t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_BASE') }}: {{ item.rowInfo.base !== '' ? $n(item.rowInfo.base, 'number') : '--' }} % | 
                                                        {{ $t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_REGION') }}: {{ item.rowInfo.region !== '' ? item.rowInfo.region : '--' }} | 
                                                        {{ $t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_APPLY_TO') }}: {{ item.rowInfo.refundFrom !== '' ? $t(getApplyTo(item.rowInfo.refundFrom)) : '--' }}
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                    <!-- <div v-else-if="entry[0].error === 1"> -->
                                    <v-row v-else-if="entry[0].error === 1" class="mt-1">
                                        <v-col cols="1">
                                            <v-chip  
                                                small 
                                                label
                                                color="errorLineChip"
                                                text-color="errorLineText"
                                                class="ml-4"
                                                :alvqa="alvqa + '-result-chip-error'"
                                            >{{ $t('lang_GENERAL_CAPTION_ERROR') }}</v-chip>
                                        </v-col>
                                        <v-col :alvqa="alvqa + '-result-error-text'">
                                            {{ entry[0].rowInfo.error }}
                                        </v-col>
                                    </v-row>
                                </v-col> 
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot:dialogActions>
                <v-container fluid>
                    <v-row>
                        <v-spacer />
                        <v-col class="text-right">
                            <BaseButton 
                                label="lang_GENERAL_CAPTION_CALCULATE"
                                @click="passes(calculate)"
                                :alvqa="alvqa+'-button-calculate'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </BaseDialog>
    </ValidationObserver>    
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseCheckbox from '@/components/_base/BaseCheckbox'

import { DropdownContractsPublishingApplyTo } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "TestCalculationSvdDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseTooltip,
        BaseCheckbox
    },
    data() {
        return {
            context: "TestCalculationSvd",
            alvqa: 'publishing-works-list-dialog-test-calculation-svd'
        }
    },
    computed: {
        itemsPerPage() { return this.$store.getters.getItemsPerPage },

        // Dropdowns
        rightsItems() { 
            let rightsArr
            let rights = this.$store.getters.getTestCalculationSvdFormTypeOfRightsValues 

            if(rights !== undefined) {
                rightsArr = JSON.parse(JSON.stringify(rights))
                let alvqaCounter = 0 // need a temp counter for the alvqa
                rightsArr.forEach(element => {
                    // let alvqa = this.$t(element.text, 'en').toLowerCase().replace(/ /g, "-") // is not working, because we dont have english translations here, and we need english for alvqas
                    element['alvqa'] = this.alvqa + '-dropdown-rights-' + alvqaCounter
                    alvqaCounter++
                });
            }

            return rightsArr
        },
        countryItems() { return this.$alvPlugin.getListOfTranslatedCountries() },

        result: {
            get() { return this.$store.getters.getTestCalculationSvdResult},
            set(result) { this.$store.commit('setTestCalculationSvdResult', result) }
        } ,
        errorMessage: { 
            get() { return this.$store.getters.getTestCalculationSvdResultErrorMessage },
            set(msg) { this.$store.commit('setTestCalculationSvdResultErrorMessage', msg) }
        },

        showDialog: {
            get() { return this.$store.getters.getTestCalculationSvdDialog },
            set(show) { this.$store.commit('setTestCalculationSvdDialog', show) }
        },
        
        resultHeaders() {
            return [
                {
					text: '', 
					value: 'contractLine', 
                    align: 'center',
                    width: "95px",
                    sortable: false,
					class: 'text-no-wrap'
                },
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_STATEMENT_FOR'), 
					value: 'name_alv', 
					align: 'left',
                    sortable: false,
					class: 'text-no-wrap'
                },
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_AMOUNT') + ' ' + this.$store.getters.getSelectedCurrency,
					value: 'total_net_val', 
                    align: 'right', 
                    width: "140px",
                    sortable: false,
					class: 'text-no-wrap'
                }, 
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_BASE') + ' %',
					value: 'contract_base', 
                    align: 'right', 
                    width: "90px",
                    sortable: false,
					class: 'text-no-wrap'
                }, 
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_SHARE') + ' %',
					value: 'contract_share', 
                    align: 'right', 
                    width: "90px",
                    sortable: false,
					class: 'text-no-wrap'
                }, 
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_SHARE') + ' ' + this.$store.getters.getSelectedCurrency,
					value: 'eur_net', 
                    align: 'right', 
                    width: "140px",
                    sortable: false,
					class: 'text-no-wrap'
                },
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_CALCULATION_RULE'), 
					value: 'rule_applied', 
					align: 'left',
                    sortable: false,
					class: 'text-no-wrap'
                },
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_PUBLISHING_CONTRACT'), 
					value: 'contract_match_id', 
                    align: 'left',
                    width: "160px",
                    sortable: false,
					class: 'text-no-wrap'
                },
				{
					text: this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_TYPE'), 
					value: 'type_of_contract', 
                    align: 'left',
                    width: "125px",
                    sortable: false,
					class: 'text-no-wrap'
                }
            ]
        },        
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.$store.commit('setSelectedWorksAction', [])
            this.$store.commit('setSelectedWorks', [])
            this.result = []
            this.errorMessage = null
            this.$store.commit('setIsAllSelectedWorks', false)
            this.$store.commit('setTestCalculationSvdCheckbox', [])
        },
        calculate() {
            this.result = []
            this.errorMessage = null
            this.$store.dispatch('calculateSvdTestCalculation')
        },
        getContractRightConst(right) {
            let contractRights = this.$store.getters.getContractsRights
            let text = ''
            contractRights.forEach(entry => {
                if(entry.value === right) text = entry.text
            });

            return text
        },    
        getWorkName() {
            let selectedWorkAlvId = this.$store.getters.getSelectedWorks
            let works = this.$store.getters.getWorks
            let title = ''

            let match = works.find(work => work.alvId === selectedWorkAlvId[0])
            if(match !== undefined) {
                title += match.title + ' (' + match.alvId
                if(match.gemaNumber !== null && match.gemaNumber !== '') title += ' | ' + match.gemaNumber
                title += ')'
            }
            return title
        },
        getApplyTo(applyToValue) {
            let applyToValues = DropdownContractsPublishingApplyTo

            if(applyToValue === null) return ''
            else {
                let applyToMatch =  applyToValues.find(applyTo => {
                    return applyTo.value === applyToValue
                })

                if(applyToMatch !== undefined) return applyToMatch.text
            }
        },
    },
    created() {
        this.$store.commit('setCountries')
    }
}
</script>